import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createUserSlice } from "./slices/loginSlice";
import { createDropdownValuesSlice } from "./slices/dropdownValuesSlice";

const useAppStore = create(
  persist(
    (set, get) => ({
      ...createUserSlice(set, get),
      ...createDropdownValuesSlice(set, get),

      clearStorage: () => {
        get().clearAuth?.();
        get().clearDropdownValues?.();
        useAppStore.persist.clearStorage();
        localStorage.clear();
        set({
          userToken: null,
          userInfo: null,
          userMobileNumber: null,
          appVersion: 3029,
        });
      },
    }),
    {
      name: "loan-app-storage",
      partialize: (state) => ({
        userToken: state.userToken,
        refreshToken: state.refreshToken,
        mobileToken: state.mobileToken,
        appVersion: state.appVersion,
        userInfo: state.userInfo,
        userMobileNumber: state.userMobileNumber,
      }),
    },
  ),
);

export default useAppStore;
